import { render, staticRenderFns } from "./MotionDescriptionViz.vue?vue&type=template&id=3f4af396&scoped=true"
import script from "./MotionDescriptionViz.vue?vue&type=script&lang=js"
export * from "./MotionDescriptionViz.vue?vue&type=script&lang=js"
import style0 from "./MotionDescriptionViz.vue?vue&type=style&index=0&id=3f4af396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4af396",
  null
  
)

export default component.exports